module.exports = __webpack_public_path__ + "img/recruit_line_2.48236782.png";